import { Clock, Send, Check, Eye, MousePointerClick, AlertTriangle, XCircle, Ban } from 'lucide-preact'

interface StatusStyle {
    label: string
    classes: string
    icon: typeof Clock
}

// Display style per stored EmailSend status (the row badge + the flyout). Clicks are privileged (primary
// green); bounced/failed/complained are red/amber; everything mid-funnel is neutral slate — mirroring the
// ORB-384 engagement vocabulary.
const STATUS_STYLES: Record<string, StatusStyle> = {
    Scheduled: { label: 'Scheduled', classes: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300', icon: Clock },
    Queued: { label: 'Queued', classes: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300', icon: Clock },
    Dispatching: { label: 'Sending', classes: 'bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-300', icon: Send },
    Sent: { label: 'Sent', classes: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300', icon: Send },
    Delivered: { label: 'Delivered', classes: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300', icon: Check },
    Opened: { label: 'Opened', classes: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300', icon: Eye },
    Clicked: { label: 'Clicked', classes: 'bg-primary-50 text-primary-700 dark:bg-primary-950/40 dark:text-primary-400', icon: MousePointerClick },
    Bounced: { label: 'Bounced', classes: 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400', icon: AlertTriangle },
    Complained: { label: 'Complained', classes: 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400', icon: AlertTriangle },
    Failed: { label: 'Failed', classes: 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400', icon: XCircle },
    'Delivery Delayed': { label: 'Delayed', classes: 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400', icon: Clock },
    'Skipped (Suppressed)': { label: 'Skipped', classes: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400', icon: Ban },
}

const FALLBACK_STYLE: StatusStyle = {
    label: '',
    classes: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
    icon: Clock,
}

export function EmailStatusBadge({ status }: { status: string }) {
    const style = STATUS_STYLES[status] ?? { ...FALLBACK_STYLE, label: status }
    const IconComponent = style.icon
    return (
        <span class={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-medium ${style.classes}`}>
            <IconComponent size={11} />
            {style.label}
        </span>
    )
}
